var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowRightCircle = function SvgArrowRightCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15ZM6.793 16h15.414l1-1L15.5 7.293l-1.414 1.414L19.379 14H6.793v2Zm10.586 2h2.828L15.5 22.707l-1.414-1.414L17.379 18Z",
    fill: "currentColor"
  })));
};

export { SvgArrowRightCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzAgMzAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTUgMEM2LjcxNTczIDAgMCA2LjcxNTczIDAgMTVDMCAyMy4yODQzIDYuNzE1NzMgMzAgMTUgMzBDMjMuMjg0MyAzMCAzMCAyMy4yODQzIDMwIDE1QzMwIDYuNzE1NzMgMjMuMjg0MyAwIDE1IDBaTTYuNzkyOTcgMTYuMDAwMkwyMi4yMDczIDE2TDIzLjIwNzIgMTUuMDAwMUwxNS41MDAxIDcuMjkyOTdMMTQuMDg1OSA4LjcwNzE4TDE5LjM3ODkgMTQuMDAwMkw2Ljc5Mjk3IDE0LjAwMDJWMTYuMDAwMlpNMTcuMzc4OCAxOEgyMC4yMDczTDE1LjQ5OTkgMjIuNzA3M0wxNC4wODU3IDIxLjI5MzFMMTcuMzc4OCAxOFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";